import { forwardRef } from 'react';
import { Field, WrappedFieldProps } from 'redux-form';
import { ReadOnly, ReadOnlyProps } from '@mews-commander/ui';
import { getError } from '../../utils';

type ReadOnlyFieldRendererProps = WrappedFieldProps & ReadOnlyProps;

const ReadOnlyFieldRenderer = ({ input, meta, ...other }: ReadOnlyFieldRendererProps) => (
    <ReadOnly error={getError(meta)} {...other} {...input} />
);

const ReadOnlyField = forwardRef<HTMLInputElement, ReadOnlyProps>((props, ref) => (
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    <Field component={ReadOnlyFieldRenderer} ref={ref} {...props} />
));

export default ReadOnlyField;
